var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ajaxSearch) ? _c('div', [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "medium",
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.placeholder,
      "trigger-on-focus": true
    },
    on: {
      "select": _vm.handleSelect
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.enterKeyFn($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('i', {
    class: _vm.keyword ? 'circle-close' : '',
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.iconClickHandler
    },
    slot: "suffix"
  })])], 1) : _c('div', [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "medium",
      "placeholder": _vm.placeholder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.enterKeyFn($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('i', {
    class: _vm.keyword ? 'circle-close' : '',
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.iconClickHandler
    },
    slot: "suffix"
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48148d24"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchPanel/searchBar.vue
// module id = null
// module chunks = 